import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "selector", "submit"]

  connect() {
    this.update()
  }

  update() {
    const source = this.selectorTarget.value

    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.source !== source
    })

    const label = source === "pasted_text" ? "Prepare menu for review" : "Send menu for setup"
    if (this.submitTarget instanceof HTMLInputElement) {
      this.submitTarget.value = label
    } else {
      this.submitTarget.textContent = label
    }
    this.submitTarget.dataset.disableWith = label
  }
}
